// Browser metricName
export const browser_app_page_ajax_error_sum = 'Ajax';
export const browser_app_page_resource_error_sum = 'Resources';
export const browser_app_page_js_error_sum = 'Js';
export const browser_app_page_unknown_error_sum = 'Others';
export const k8s_node_v2_cpu_cores_requests = 'Cores Requested';
export const k8s_node_v2_memory_usage_bytes = 'Memory Usage'
export const k8s_node_v2_cpu_cores_usage = 'Cores Usage';
export const k8s_node_v2_cpu_usage = 'CPU Usage';
export const k8s_node_v2_cpu_cores_limits = 'Cores Limit';
export const k8s_node_v2_memory_requests = 'Memory Requested';
export const k8s_node_v2_memory_limits = 'Memory Limit';
export const k8s_node_v2_memory_usage = 'Memory Usage';
export const k8s_node_v2_network_read = 'Network Read';
export const k8s_node_v2_network_write = 'Network Write';
export const k8s_node_v2_network_receive = 'Packets Received';
export const k8s_node_v2_network_transmit = 'Packets Sent';
export const k8s_node_v2_fs_write_bytes = 'FS Writes';
export const k8s_node_v2_fs_read_bytes = 'FS Reads';
export const k8s_node_v2_fs_writes_total = 'FS Writes Total';
export const k8s_node_v2_fs_reads_total = 'FS Reads Total';
export const k8s_pods_v2_cpu_cores_requests = 'Cores Requested';
export const k8s_pods_v2_cpu_cores_limits = 'Cores Limit';
export const k8s_pods_v2_cpu_cores_usage = 'CPU  Usage';
export const k8s_pods_v2_memory_requests = 'Memory Requested';
export const k8s_pods_v2_memory_limits = 'Memory Limit';
export const k8s_pods_v2_memory_usage_bytes = 'Memory Usage';
export const k8s_pods_v2_network_read = 'Network Read';
export const k8s_pods_v2_network_write = 'Network Write';
export const k8s_pods_v2_network_transmit = 'Packets Sent';
export const k8s_pods_v2_network_receive = 'Packets Received';
export const k8s_pods_v2_fs_writes_total = 'FS Writes Total';
export const k8s_pods_v2_fs_reads_total = 'FS Reads Total';
export const k8s_pods_v2_fs_read_bytes = 'FS Reads';
export const k8s_pods_v2_fs_write_bytes = 'FS Writes';
export const otel_jvm_thread_metrics = 'instance_jvm_thread_live_count, instance_jvm_thread_daemon_count';
export const ss_jvm_thread_metrics = 'instance_jvm_thread_live_count, instance_jvm_thread_daemon_count, instance_jvm_thread_peak_count';
export const jvm_thread_graph_title = 'JVM thread count';
// export const instance_jvm_memory_heap = 'Heap';
// export const instance_jvm_memory_heap_max = 'Heap max';
// export const instance_jvm_memory_noheap = 'Noheap';
// export const instance_jvm_memory_noheap_max = 'Noheap max';
// export const instance_jvm_young_gc_time = 'Young GC time';
// export const instance_jvm_old_gc_time = 'Old GC time';
// export const instance_jvm_young_gc_count = 'Young GC count';
// export const instance_jvm_old_gc_count = 'Old GC count';
